export enum DepartmentCode {
  TSN = "1",
  NB = "2",
  DN = "3",
  IT = "IT",
  OAP = "OAP",
  ECO = "ECO",
  CO = "CO",
  IP = "IP",
  AF = "AF",
  TC = "TC",
  SCBD = "SCBD",
  CC = "CC",
  SQ = "SQ",
  KCQ = "KCQ", // Khối cơ quan
}

export const branchList = [
  DepartmentCode.TSN,
  DepartmentCode.NB,
  DepartmentCode.DN,
];

export const departments = [
  {
    label: "Chi nhánh Tân Sơn Nhất",
    value: `${DepartmentCode.TSN}|Chi nhánh Tân Sơn Nhất`,
  },
  {
    label: "Chi nhánh Nội Bài",
    value: `${DepartmentCode.NB}|Chi nhánh Nội Bài`,
  },
  {
    label: "Chi nhánh Đà Nẵng",
    value: `${DepartmentCode.DN}|Chi nhánh Đà Nẵng`,
  },
  {
    label: "Phòng Công nghệ thông tin",
    value: `${DepartmentCode.IT}|Phòng Công nghệ thông tin`,
  },
  {
    label: "Phòng Tổ chức và nhân lực",
    value: `${DepartmentCode.OAP}|Phòng Tổ chức và nhân lực`,
  },
  {
    label: "Phòng Kinh doanh",
    value: `${DepartmentCode.ECO}|Phòng Kinh doanh`,
  },
  {
    label: "Văn phòng công ty",
    value: `${DepartmentCode.CO}|Văn phòng công ty`,
  },
  {
    label: "Phòng Kế hoạch đầu tư",
    value: `${DepartmentCode.IP}|Phòng Kế hoạch đầu tư`,
  },
  {
    label: "Phòng Tài chính kế toán",
    value: `${DepartmentCode.AF}|Phòng Tài chính kế toán`,
  },
  {
    label: "Trung tâm đào tạo",
    value: `${DepartmentCode.TC}|Trung tâm đào tạo`,
  },
  {
    label: "Trung tâm SC&BD TTB",
    value: `${DepartmentCode.SCBD}|Trung tâm SC&BD TTB`,
  },
  {
    label: "Trung tâm Kiểm soát tải",
    value: `${DepartmentCode.CC}|Trung tâm Kiểm soát tải`,
  },
  {
    label: "Phòng An toàn chất lượng và An ninh",
    value: `${DepartmentCode.SQ}|Phòng An toàn chất lượng và An ninh`,
  },
];

export const departmentList = [
  {
      "key": 0,
      "label": "Công nghệ thông tin",
      "value": "IT"
  },
  {
      "key": 2,
      "label": "Tổ chức và Nhân lực",
      "value": "OAP"
  },
  {
      "key": 5,
      "label": "Kinh Doanh",
      "value": "ECO"
  },
  {
      "key": 8,
      "label": "Văn phòng Công ty",
      "value": "CO"
  },
  {
      "key": 14,
      "label": "Kế hoạch Đầu tư",
      "value": "IP"
  },
  {
      "key": 17,
      "label": "Tài chính Kế toán",
      "value": "AF"
  },
  {
      "key": 20,
      "label": "Trung tâm đào tạo",
      "value": "TC"
  },
  {
      "key": 24,
      "label": "Trung tâm SC&BD TTB",
      "value": "SCBD"
  },
  {
      "key": 30,
      "label": "Trung tâm kiểm soát tải",
      "value": "CC"
  },
  {
      "key": 34,
      "label": "An toàn Chất lượng và An ninh",
      "value": "SQ"
  },
  {
      "key": 37,
      "label": "Ban Giám đốc",
      "value": "BGD1"
  },
  {
      "key": 39,
      "label": "Trung tâm điều hành TSN",
      "value": "HQ1"
  },
  {
      "key": 42,
      "label": "Trung tâm phục vụ sân đỗ TSN",
      "value": "PSC1"
  },
  {
      "key": 47,
      "label": "Trung tâm phục vụ hành khách TSN",
      "value": "PVHK1"
  },
  {
      "key": 51,
      "label": "Nhóm hành chính tổng hợp TSN",
      "value": "GA1"
  },
  {
      "key": 55,
      "label": "Phòng kế hoạch hành chính NBA",
      "value": "AP2"
  },
  {
      "key": 59,
      "label": "Phòng kế toán NBA",
      "value": "KT2"
  },
  {
      "key": 61,
      "label": "Trung tâm phục vụ sân đỗ NBA",
      "value": "PSC2"
  },
  {
      "key": 66,
      "label": "Trung tâm phục vụ hành khách NBA",
      "value": "PVHK2"
  },
  {
      "key": 72,
      "label": "Trung tâm điều hành NBA",
      "value": "HQ2"
  },
  {
      "key": 75,
      "label": "Ban Giám đốc DAD",
      "value": "BGD3"
  },
  {
      "key": 78,
      "label": "Phòng kế hoạch hành chính DAD",
      "value": "AP3"
  },
  {
      "key": 81,
      "label": "Phòng kế toán DAD",
      "value": "KT3"
  },
  {
      "key": 82,
      "label": "Trung tâm phục vụ sân đỗ DAD",
      "value": "PSC3"
  },
  {
      "key": 84,
      "label": "Trung tâm phục vụ hành khách DAD",
      "value": "PVHK3"
  },
  {
      "key": 87,
      "label": "Trung tâm điều hành DAD",
      "value": "HQ3"
  },
  {
      "key": 90,
      "label": "Trung tâm Phục vụ hàng hóa DAD",
      "value": "PVHH3"
  },
  {
      "key": 92,
      "label": "PHÒNG CNTT",
      "value": "IT"
  },
  {
      "key": 115,
      "label": "Đội ĐBVH & Hạ tầng",
      "value": "ITDHT"
  },
  {
      "key": 117,
      "label": "Đội Phát triển CNTT",
      "value": "ITDPT"
  },
  {
      "key": 123,
      "label": "Đội Quản trị CNTT",
      "value": "ITDQT"
  },
  {
      "key": 129,
      "label": "Đội Chuyển đổi số",
      "value": "ITCDS"
  },
  {
      "key": 134,
      "label": "TRUNG TÂM ĐIỀU HÀNH",
      "value": "TTDHNBA"
  },
  {
      "key": 135,
      "label": "TRUNG TÂM PHỤC VỤ HÀNH KHÁCH",
      "value": "PVHKNBA"
  },
  {
      "key": 140,
      "label": "TRUNG TÂM PHỤC VỤ SÂN ĐỖ",
      "value": "PVSDNBA"
  },
  {
      "key": 141,
      "label": "PHÒNG KẾ HOẠCH HÀNH CHÍNH",
      "value": "KHHCNBA"
  },
  {
      "key": 164,
      "label": "KẾ TOÁN",
      "value": "KTNBA"
  },
  {
      "key": 373,
      "label": "Bộ phận Hành chính",
      "value": "BPHC"
  },
  {
      "key": 374,
      "label": "Nhóm Kế hoạch đầu tư, mua sắm",
      "value": "KHDTMS"
  },
  {
      "key": 376,
      "label": "Tổ Quản trị tòa nhà",
      "value": "QTTN"
  },
  {
      "key": 379,
      "label": "Bộ phận Đảng, đoàn thể",
      "value": "BPDDT"
  },
  {
      "key": 383,
      "label": "Nhóm Dữ liệu",
      "value": "NDL"
  },
  {
      "key": 384,
      "label": "Nhóm Chất lượng",
      "value": "NCL"
  },
  {
      "key": 385,
      "label": "Nhóm Hợp đồng và Phát triển bán",
      "value": "NHDVPTB"
  },
  {
      "key": 386,
      "label": "Trung tâm đào tạo khu vực miền Nam",
      "value": "TTDTKVMN"
  },
  {
      "key": 387,
      "label": "Trung tâm Đào tạo",
      "value": "TTDT"
  },
  {
      "key": 390,
      "label": "Trung tâm đào tạo khu vực miền Bắc",
      "value": "TTDT"
  },
  {
      "key": 400,
      "label": "Nhóm An toàn",
      "value": "NAT"
  },
  {
      "key": 401,
      "label": "Nhóm Đào tạo và hành chính tổng hợp",
      "value": "NDTVHCTH"
  },
  {
      "key": 402,
      "label": "Nhóm Kế toán",
      "value": "NKT"
  },
  {
      "key": 405,
      "label": "Nhóm Tài chính",
      "value": "NTC"
  },
  {
      "key": 406,
      "label": "Nhóm Tổ chức lao động",
      "value": "NTCLD"
  },
  {
      "key": 407,
      "label": "Nhóm Tiền lương chính sách",
      "value": "NTLCS"
  },
  {
      "key": 408,
      "label": "Nhóm Marketing",
      "value": "NMARKETING"
  },
  {
      "key": 410,
      "label": "Nhóm An ninh",
      "value": "NAN"
  },
  {
      "key": 417,
      "label": "Đội kiểm soát tải NBA",
      "value": "DKSTNBA"
  },
  {
      "key": 419,
      "label": "Đội điều hành và Quản trị cơ sở dữ liệu",
      "value": "DDHQTCSDL"
  },
  {
      "key": 420,
      "label": "Trung tâm đào tạo khu vực miền Trung",
      "value": "TTDTKVMT"
  },
  {
      "key": 422,
      "label": "Đội dịch vụ phòng khách Bông Sen",
      "value": "DDVPKBS"
  },
  {
      "key": 449,
      "label": "Bộ phận Y tế",
      "value": "BPYT"
  },
  {
      "key": 454,
      "label": "Khối văn phòng",
      "value": "KVP"
  },
  {
      "key": 465,
      "label": "Bộ phận thư ký tổng hợp",
      "value": "BPTKTH"
  },
  {
      "key": 468,
      "label": "Bộ phận Truyền thông",
      "value": "BPTT"
  },
  {
      "key": 494,
      "label": "Xưởng SC & BD TTB NBA",
      "value": "XSCBDTTBNBA"
  },
  {
      "key": 498,
      "label": "Xưởng SC & BD TTB DAD",
      "value": "XSCBDTTBDAD"
  },
  {
      "key": 499,
      "label": "Xưởng SC & BD TTB TSN",
      "value": "XSCBDTTBTSN"
  },
  {
      "key": 519,
      "label": "Đội Kiểm soát tải Đà Nẵng",
      "value": "KSTDN"
  },
  {
      "key": 521,
      "label": "Đội Kiểm soát tải TSN",
      "value": "KSTTSN"
  },
  {
      "key": 647,
      "label": "PVTB Kíp 2",
      "value": "PVTVK2"
  },
  {
      "key": 648,
      "label": "Đội Cung ứng vật tư",
      "value": "DCUVT"
  },
  {
      "key": 649,
      "label": "PVVT Kíp Cấp phát",
      "value": "PVVTKCP"
  },
  {
      "key": 652,
      "label": "PVVT Kíp Đóng gói",
      "value": "PVVTKDG"
  },
  {
      "key": 654,
      "label": "PVVT Văn phòng",
      "value": "PVVTVP"
  },
  {
      "key": 655,
      "label": "Văn phòng Phục vụ sân đỗ",
      "value": "VPPVSD"
  },
  {
      "key": 657,
      "label": "DVKT Văn phòng",
      "value": "DVKTVP"
  },
  {
      "key": 658,
      "label": "Đội Hướng dẫn chất xếp",
      "value": "DHDCX"
  },
  {
      "key": 661,
      "label": "PVHL Kíp 1",
      "value": "PVHKK1"
  },
  {
      "key": 662,
      "label": "DVSĐ Kíp 16 BX",
      "value": "DVSDK16"
  },
  {
      "key": 669,
      "label": "PVTB Văn phòng",
      "value": "PVTBVP"
  },
  {
      "key": 672,
      "label": "DVSĐ Văn phòng",
      "value": "DVSDVP"
  },
  {
      "key": 675,
      "label": "Đội Phục vụ hành khách Quốc nội",
      "value": "PVHKQN"
  },
  {
      "key": 677,
      "label": "Đội Phục vụ Hành khách các Hãng",
      "value": "PVHKCH"
  },
  {
      "key": 679,
      "label": "PVHL Văn phòng",
      "value": "PVHLVP"
  },
  {
      "key": 683,
      "label": "Tổ Quản lý chất lượng",
      "value": "TQLCL"
  },
  {
      "key": 684,
      "label": "Văn phòng Trung tâm Điều hành",
      "value": "VPTTDH"
  },
  {
      "key": 685,
      "label": "Đội Phục vụ hành khách Quốc tế",
      "value": "DPVHKQT"
  },
  {
      "key": 686,
      "label": "Đội xe Phục vụ tổ bay",
      "value": "DXPVTB"
  },
  {
      "key": 687,
      "label": "HKCT LNF",
      "value": "HKCTLNF"
  },
  {
      "key": 688,
      "label": "HKCT Kíp 2",
      "value": "HKCTK2"
  },
  {
      "key": 690,
      "label": "Đội Phục vụ hành khách đến và chuyển tiếp",
      "value": "DPVHKDVCT"
  },
  {
      "key": 691,
      "label": "HKCT Kíp 1",
      "value": "HKCTK1"
  },
  {
      "key": 707,
      "label": "HKCT Văn phòng",
      "value": "HKCTVP"
  },
  {
      "key": 721,
      "label": "HKCT Kíp 3",
      "value": "HKCTK3"
  },
  {
      "key": 728,
      "label": "Đội vé sân bay",
      "value": "DVSB"
  },
  {
      "key": 734,
      "label": "Đội Phục vụ hành lý",
      "value": "DPVHL"
  },
  {
      "key": 765,
      "label": "Bộ phận Hành chính Tổng hợp",
      "value": "BPHCTH"
  },
  {
      "key": 777,
      "label": "Văn phòng Trung tâm PVHK",
      "value": "VPTTPVHK"
  },
  {
      "key": 783,
      "label": "Đội Dịch vụ kỹ thuật",
      "value": "DDVKT"
  },
  {
      "key": 805,
      "label": "PVHL Kíp 5",
      "value": "PVHLK5"
  },
  {
      "key": 806,
      "label": "PVHL Kíp 6",
      "value": "PVHLK6"
  },
  {
      "key": 807,
      "label": "PVHL Kíp 2",
      "value": "PVHLK2"
  },
  {
      "key": 808,
      "label": "PVHL Kíp 3",
      "value": "PVHLK3"
  },
  {
      "key": 858,
      "label": "PVVT Kíp Giặt là",
      "value": "PVVTKGL"
  }
]